/**************************************************************************************************/
/*   File: /src/app/stores/actions/details/creation.actions.ts                                       */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Tuesday February 19th 2019                                                     */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Mon May 06 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { Action } from '@ngrx/store';

import * as fromShared from '../../../shared';
import { LocalDocumentId } from '../../../shared/models';

/**
 * The dossier details action types enum
 */
export enum DossierDetailsActionsType {

  CHECK_DOSSIER_STATUS = '[Details] Check dossier status',
  CHECK_DOSSIER_STATUS_SUCCESS = '[Details] Check dossier status success',
  CHECK_DOSSIER_STATUS_FAIL = '[Details] Check dossier status fail',

  LOAD_DOSSIER = '[Details] Load dossier',
  LOAD_DOSSIER_SUCCESS = '[Details] Load dossier success',
  LOAD_DOSSIER_FAIL = '[Details] Load dossier fail',

  LOAD_DOSSIER_PUBLIC = '[Details] Load dossier public',

  LOAD_INITIAL_STATE = '[Details] Load initial state'
}
/**
 * Check dossier status
 */
export class CheckDossierStatus implements Action {
  /**
   * The type
   */
  readonly type = DossierDetailsActionsType.CHECK_DOSSIER_STATUS;

  /**
   * The constructor
   * @param payload containing dossier status
   */
  constructor(public payload: { dossierId: fromShared.models.DossierId }) {
  }
}
/**
 * Check dossier status success
 */
export class CheckDossierStatusSuccess implements Action {
  /**
   * The type
   */
  readonly type = DossierDetailsActionsType.CHECK_DOSSIER_STATUS_SUCCESS;

  /**
   * The constructor 
   * @param payload containing the status
   */
  constructor(public payload: { status: fromShared.models.DossierStatus, dossierId: fromShared.models.DossierId }) {
  }
}
/**
 * Check dossier status fail
 */
export class CheckDossierStatusFail implements Action {
  /**
   * The type
   */
  readonly type = DossierDetailsActionsType.CHECK_DOSSIER_STATUS_FAIL;

  /**
   * The constructor
   * @param payload containing message
   */
  constructor(public payload: { message: fromShared.models.Message }) {
  }
}
/**
 * Load dossier 
 */
export class LoadDossier implements Action {
  /**
   * The type
   */
  readonly type = DossierDetailsActionsType.LOAD_DOSSIER;

  /**
   * The constructor
   * @param payload containing dossier id
   */
  constructor(public payload: { dossierId: fromShared.models.DossierId }) {
  }
}
export class LoadDossierPublic implements Action {
  readonly type = DossierDetailsActionsType.LOAD_DOSSIER_PUBLIC

  constructor(public payload: { dossierId: fromShared.models.DossierId })
  {}
}


/**
 * Load dossier success
 */
export class LoadDossierSuccess implements Action {
  /**
   * The type
   */
  readonly type = DossierDetailsActionsType.LOAD_DOSSIER_SUCCESS;

  /**
   * The constructor 
   * @param payload containing the dossier
   */
  constructor(public payload: { dossier: fromShared.models.Dossier }) {
  }
}
/**
 * Load dossier fail
 */
export class LoadDossierFail implements Action {
  /**
   * The type
   */
  readonly type = DossierDetailsActionsType.LOAD_DOSSIER_FAIL;

  /**
   * The constructor
   * @param payload containing message
   */
  constructor(public payload: { message: fromShared.models.Message }) {
  }
}

export class LoadInitialState implements Action {
  readonly type = DossierDetailsActionsType.LOAD_INITIAL_STATE;

  constructor() {
  }
}


/**
 * The dossier actions type
 */
export type DossierDetailsActions =
  CheckDossierStatus |
  CheckDossierStatusSuccess |
  CheckDossierStatusFail |
  LoadDossier |
  LoadDossierSuccess |
  LoadDossierPublic |
  LoadInitialState |
  LoadDossierFail;
